function dayKeyLocal(ts) {
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
}

function parseDayKey(dayKey) {
  const [y, m, d] = dayKey.split("-").map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

function addDays(dayKey, delta) {
  const d = parseDayKey(dayKey);
  d.setDate(d.getDate() + delta);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
}

function computeBestStreak(sortedDays) {
  if (sortedDays.length === 0) return 0;
  let best = 1;
  let cur = 1;
  for (let i = 1; i < sortedDays.length; i++) {
    const prev = sortedDays[i - 1];
    const expected = addDays(prev, 1);
    if (sortedDays[i] === expected) {
      cur += 1;
      if (cur > best) best = cur;
    } else {
      cur = 1;
    }
  }
  return best;
}

function computeCurrentStreak(daySet) {
  if (daySet.size === 0) return 0;
  const todayKey = dayKeyLocal(new Date());
  let streak = 0;
  let k = todayKey;

  // If no ping today, streak can still be active if yesterday was last day
  if (!daySet.has(k)) {
    k = addDays(todayKey, -1);
  }

  while (daySet.has(k)) {
    streak += 1;
    k = addDays(k, -1);
  }

  return streak;
}

export function computeStreaks({ pings, meId }) {
  const myDays = new Set();
  const partnerDays = new Set();

  for (const p of pings) {
    const dk = dayKeyLocal(p.created_at);
    if (p.sender_id === meId) myDays.add(dk);
    else partnerDays.add(dk);
  }

  const connectionDays = new Set();
  for (const dk of myDays) {
    if (partnerDays.has(dk)) connectionDays.add(dk);
  }

  const mySorted = Array.from(myDays).sort();
  const connSorted = Array.from(connectionDays).sort();

  const personal = {
    current: computeCurrentStreak(myDays),
    best: computeBestStreak(mySorted),
  };

  const connection = {
    current: computeCurrentStreak(connectionDays),
    best: computeBestStreak(connSorted),
  };

  return { personal, connection };
}
